import { border } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { sizes } from "../../constants/spacing";

export const paginationTheme = themed({
    container: {
        padding: {
            "lodestar-light": "0 6px",
            "ursa-light": `${sizes.xxSmall}px`,
        },
        height: {
            "lodestar-light": "40px",
            "ursa-light": "36px",
        },
        borderRadius: {
            "lodestar-light": border.radius10,
            "ursa-light": border.radius30,
        },
        boxShadow: {
            "lodestar-light": "0px 8px 24px rgba(0, 0, 0, 0.12)",
            "ursa-light": color("elevation--default"),
        },
        background: color("color--background--surfaces--work"),
        space: {
            "lodestar-light": "small",
            "ursa-light": "xxSmall",
        },
    },
    text: {
        padding: {
            "lodestar-light": "0px",
            "ursa-light": `0 ${sizes.xSmall}px`,
        },
        variant: {
            "lodestar-light": "bodyText",
            "ursa-light": "Inter--14px--500w",
        },
    },
    iconButton: {
        width: {
            "lodestar-light": "", //size overrides this style
            "ursa-light": "28px",
        },
        height: {
            "lodestar-light": "", //size overrides this style
            "ursa-light": "28px",
        },
        size: {
            "lodestar-light": "medium",
            "ursa-light": "small",
        },
        appearance: {
            "lodestar-light": "borderless",
            "ursa-light": "secondary-empty",
        },
    },
} as const);
